import { Model, Attr } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';

@Model()
export default class ExtrasStats extends ApplicationRecord {
  static jsonapiType = 'extras-stats';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
    ];
  }

  static scopeFactory() {
    return ExtrasStats.includes([]);
  }

  @Attr() startDatetime: string;
  @Attr() endDatetime: string;
  @Attr() stats: { [key: string]: number };
}
